import React, { useEffect, useState } from 'react';
import { Button, Form, Row, Col } from 'antd';
import { SelectField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import DateRangeDropdown from '../DateRangeDropdown';
import { useTranslate } from 'Translate';

export default (props) => {

  const { control, handleSubmit, setValue, getValues } = useForm();
  const [field2, setField2] = useState();
  const i18n = useTranslate();
  const { t } = i18n;

  useEffect(() => {
    if (props) {
      if (!getValues().start_date) {
        setValue('start_date', dayjs());
        setValue('dateRange', { label: t("General.today"), value: 'today' });
      }
      if (!getValues().end_date) {
        setValue('end_date', dayjs());
      }
      if (!getValues().regions.length > 0) {
        setField2(props.field2);
      }
    }
  }, [props]);

  const onSubmit = (val) => {
    props.onSearch(val);
  };

  const onRegionChange = (e) => {
    if(e.some(y => y.label == t("General.all_regions"))) {
      setValue('regions', []);
      setField2(props.field2)
    } else {
      let outlets = props.field2.filter(x => e.some(y => y.value === x.region_id));
      setField2(outlets);
    }
  }

  return (
    <Form onFinish={handleSubmit(onSubmit)} layout="inline" className='w-100 inline-form'>
      <Row className='w-100' gutter={[10, 10]}>
        <DateRangeDropdown control={control} onSetValue={setValue} placeholderValue='Search' isRequired={false} />

        <Col flex="auto">
          <SelectField
            fieldname='regions'
            label=''
            class='mb-0 w-100 default-select'
            initValue={[]}
            control={control}
            selectOption={props.field1}
            onChange={onRegionChange}
            iProps={{ placeholder: t("General.all_regions"), isMulti: true }}
          />
        </Col>

        <Col flex="auto">
          <SelectField
            fieldname='outlets'
            label=''
            class='mb-0 w-100 default-select'
            initValue={''}
            control={control}
            selectOption={field2}
            iProps={{ placeholder: t("General.all_outlets"), isMulti: true }}
          />
        </Col>

        <Col flex="auto">
          <SelectField
            fieldname='is_non_sales'
            label=''
            class='mb-0 w-100 default-select'
            initValue={{ label: "Non Sales: All", value: "all" }}
            control={control}
            selectOption={[{
              label: "Non Sales: All",
              value: "all"
            }, {
              label: "Non Sales: No",
              value: "no"
            }, {
              label: "Non Sales: Yes",
              value: "yes"
            }]}
            iProps={{ placeholder: 'Is Non Sales' }}
          />
        </Col>

        <Col flex="70px">
          <Button className='w-100' size='large' type='primary' htmlType='submit'>{t("General.search")}</Button>
        </Col>
      </Row>
    </Form>
  )
}